import createAction from "@web-monorepo/infra/createAction";
import createActionCreator from "@web-monorepo/infra/createActionCreator";
import createAsyncActions from "@web-monorepo/infra/createAsyncActions";
import type { ToolkitAction } from "src/state/toolkitReduxStore";

export const [FETCH_HOST_STATE, FETCH_HOST_STATE_DONE] = createAsyncActions("realtime/fetchHostState");
export const fetchHostState = createActionCreator(FETCH_HOST_STATE);
export const fetchHostStateDone = (hasHost: boolean) => ({
  type: FETCH_HOST_STATE_DONE,
  payload: { hasHost },
});

// display

export const DISPLAY_OPEN = createAction("DISPLAY_OPEN");
export const DISPLAY_CLOSE = createAction("DISPLAY_CLOSE");

export const displayOpen = createActionCreator(DISPLAY_OPEN, (path: string, action?: unknown) => ({
  path,
  action,
}));
export const displayClose = createActionCreator(DISPLAY_CLOSE);

export const RECEIVE_DISPLAY_OPEN = createAction("RECEIVE_DISPLAY_OPEN");
export const RECEIVE_DISPLAY_CLOSE = createAction("RECEIVE_DISPLAY_CLOSE");

export const SHARE_OVER_WIRE_SEND = createAction("SHARE_OVER_WIRE_SEND");
export const shareOverWire = (action: ToolkitAction) => ({
  type: SHARE_OVER_WIRE_SEND,
  payload: action,
});
export const SHARE_OVER_WIRE_RECEIVE = createAction("SHARE_OVER_WIRE_RECEIVE");

// remote

export const REMOTE_CLOSE = createAction("REMOTE_CLOSE");
export const RECEIVE_REMOTE_CLOSE = createAction("RECEIVE_REMOTE_CLOSE");
export const remoteClose = createActionCreator(REMOTE_CLOSE);
